import React, { useState, useEffect } from 'react';
import './Registration.css';
import { useContract } from '../hooks/useContract';
import { DEFAULT_REFERRER, PACKAGE_PRICES } from '../config/contract';
import Loader from './Loader';

const Registration = ({ onSuccess, addToast }) => {
  const [referrerId, setReferrerId] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
  const [status, setStatus] = useState('');
  const { register, isLoading } = useContract();

  useEffect(() => {
    const storedRef = localStorage.getItem('referrerId');
    if (storedRef) setReferrerId(storedRef);
  }, []);

  const handleRegister = async () => {
    if (isRegistering) return;

    const refId = referrerId ? parseInt(referrerId) : DEFAULT_REFERRER;
    
    if (isNaN(refId) || refId < 0) {
      addToast('error', 'Invalid referrer ID');
      return;
    }

    setIsRegistering(true);
    setStatus('Checking USDT approval...');
    
    try {
      const result = await register(refId);
      if (result.success) {
        setStatus('Registration successful!');
        addToast('success', 'Welcome to the Time Portal!');
        localStorage.removeItem('referrerId');
        setTimeout(onSuccess, 2000);
      } else {
        setStatus('');
        addToast('error', result.error || 'Registration failed');
      }
    } catch (error) {
      setStatus('');
      console.error('Registration error:', error);
      addToast('error', 'Registration failed. Please try again.');
    } finally {
      setIsRegistering(false);
    }
  };

  if (isLoading || isRegistering) {
    return <Loader message={status || "Opening time portal..."} />;
  }

  return (
    <div className="registration animate-fadeInUp">
      <div className="reg-portal">
        <img src="/assets/gifs/2.gif" alt="Registration" className="reg-gif" />
      </div>

      <div className="reg-content">
        <h2 className="reg-title">Begin Your Journey</h2>
        <p className="reg-subtitle">Activate your first time unit to start earning</p>

        <div className="reg-info">
          <div className="info-row">
            <span className="info-label">Entry Unit</span>
            <span className="info-value">${PACKAGE_PRICES[0]} USDT</span>
          </div>
          <div className="info-row">
            <span className="info-label">Max Return</span>
            <span className="info-value">3x (${PACKAGE_PRICES[0] * 3})</span>
          </div>
        </div>

        <div className="reg-form">
          <label className="input-label">Referrer ID (Optional)</label>
          <input
            type="text"
            className="reg-input"
            placeholder={`Default: ${DEFAULT_REFERRER}`}
            value={referrerId}
            onChange={(e) => setReferrerId(e.target.value)}
          />
        </div>

        <button
          className="reg-btn"
          onClick={handleRegister}
          disabled={isRegistering}
        >
          <span className="btn-icon">🚀</span>
          <span>Activate Time Portal</span>
        </button>
        
        <p className="reg-note">
          You will be asked to approve USDT spending first, then confirm the registration transaction.
        </p>
      </div>
    </div>
  );
};

export default Registration;
